<template>
  <div class="main-container">
    <div class="bread">
      <ExamIndexBread></ExamIndexBread>
      <span class="slash">/</span>
      <span class="current">专项练习</span>
    </div>
    <div class="content">
      <div class="empty" v-if="treeData.length == 0">
        <img src="@/assets/images/exam/empty.png" alt />
        <div class="text">
          <span>暂无专项</span>
        </div>
      </div>
      <TreeCollapse
        v-else
        :value="treeData"
        :header-title="['专项名称', '练习进度', '操作']"
      >
        <template slot="num" slot-scope="{ data }">
          {{ data.answer_num }}/{{ data.ques_num }}
        </template>
        <template slot="btn" slot-scope="{ data }">
          <el-button
            v-if="data.ques_num != 0 && data.answer_num == data.ques_num"
            type="primary"
            simple
            size="small"
            @click="onStart(data)"
          >
            重新练习
          </el-button>
          <el-button v-else type="primary" size="small" @click="onStart(data)">
            开始练习
          </el-button>
        </template>
      </TreeCollapse>
    </div>
    <LimitModal ref="limitModal" />
  </div>
</template>

<script>
import TreeCollapse from "./components/TreeCollapse";
import ExamIndexBread from "./components/ExamIndexBread.vue";

export default {
  name: "ExamPoint",
  components: {
    TreeCollapse,
    ExamIndexBread,
  },
  data() {
    return {
      visible: false,
      treeData: [],
      attr: "",
    };
  },
  created() {
    // this.requestData();
  },
  mounted() {
    this.requestData();
  },
  methods: {
    async onStart(val) {
      if (val.ques_num == 0) {
        this.$info("没有题目");
        return;
      }
      let data = await this.$http.post("/api/app/practice/report", {
        type: 3,
        practise_id: val.id,
      });
      if (data.length === 0) {
        this.$info("当前没有题目可以练习");
        return;
      }
      this.$router.push({
        name: "ExamSpecialDo",
        query: {
          id: data,
          specialName: val.name,
          specialId: val.id,
          examType: "专项练习",
        },
      });
    },
    async requestData() {
      await this.$refs.limitModal.checkAnswer(3, "专项练习");
      this.attr = await this.$services.ExamService.getAttrValId();
      const data = await this.$http.get("/api/app/special/second", {
        attr_val_id: this.attr,
      });
      this.treeData = data;
    },
  },
};
</script>
<style lang="scss" scoped>
.main-container {
  overflow: hidden;
}
.content {
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 30px;
}
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  position: relative;
}
.empty img {
  width: 400px;
}
.empty .text {
  position: absolute;
  bottom: 100px;
}
</style>
